(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer-extension"]) return;
  try {
    
  (function() {
    if (!window.cartDrawerExt) return;
    var cfg = window.cartDrawerExt;

    var SHOP_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
    var lastCurrency = 'USD';
    var lastCart = null;
    var upsellState = { seed: null, fetched: false, products: [], index: 0, sig: '' };

    function noop() {}

    function sleep(ms) {
      return new Promise(function(resolve) { setTimeout(resolve, ms); });
    }

    /* ────────────────────────────────────────────────────────────────
       Serial Ajax queue with 429 backoff

       Shopify throttles the Ajax cart API per IP and answers
       429 Too Many Requests. The theme, the installed apps and this file
       all hit /cart.js at the same moment, which pushes the browser over
       that limit. When that happens cart/add.js is rejected too, so the
       Add button appeared to do nothing at random.

       Everything below runs one request at a time and retries on 429
       (honouring Retry-After) instead of failing silently.
       ──────────────────────────────────────────────────────────────── */
    var ajaxQueue = Promise.resolve();

    function queueTask(task) {
      var out = ajaxQueue.then(task, task);
      ajaxQueue = out.then(noop, noop);
      return out;
    }

    function ajaxRequest(url, opts, attempt) {
      attempt = attempt || 0;
      return fetch(url, opts).then(function(res) {
        var throttled = (res.status === 429 || res.status === 430 || res.status === 503);
        if (throttled && attempt < 5) {
          var header = parseFloat(res.headers.get('Retry-After'));
          var wait = (header > 0) ? header * 1000 : 500 * Math.pow(2, attempt);
          if (wait > 8000) wait = 8000;
          console.warn('[cart-drawer-ext] throttled by Shopify (' + res.status + '), retry in ' + wait + 'ms', url);
          return sleep(wait).then(function() { return ajaxRequest(url, opts, attempt + 1); });
        }
        return res;
      });
    }

    function ajaxJson(url, opts) {
      return ajaxRequest(url, opts).then(function(res) {
        return res.json().catch(function() { return null; }).then(function(data) {
          if (!res.ok) {
            var err = new Error((data && (data.description || data.message)) || (url + ' returned ' + res.status));
            err.status = res.status;
            err.data = data;
            throw err;
          }
          return data;
        });
      });
    }

    var JSON_HEADERS = {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
      'Accept': 'application/json'
    };

    /* One shared /cart.js promise, so five triggers cause one request */
    var cartInflight = null;

    function getCart(force) {
      if (cartInflight && !force) return cartInflight;
      var p = queueTask(function() {
        return ajaxJson(SHOP_ROOT + 'cart.js', {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        });
      });
      cartInflight = p;
      var clear = function() { if (cartInflight === p) cartInflight = null; };
      p.then(clear, clear);
      return p;
    }

    var renderTimer = null;

    function scheduleRender(delay) {
      clearTimeout(renderTimer);
      renderTimer = setTimeout(function() {
        getCart().then(renderFromCart).catch(function(err) {
          console.warn('[cart-drawer-ext] cart fetch failed', err);
        });
      }, (delay == null ? 150 : delay));
    }

    /* compare-at price lookup: variant_id -> compare_at_price in cents */
    var compareCache = {};
    (function seedCompare() {
      var m = cfg.compareMap || {};
      for (var k in m) { if (m.hasOwnProperty(k)) compareCache[k] = m[k]; }
    })();
    var compareFetchTried = {};

    function formatMoney(cents, iso) {
      try {
        if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
          return window.theme.Currency.formatMoney(cents, window.theme.moneyFormat);
        }
      } catch (e) {}
      /* Laatste redmiddel als theme.Currency er niet is. Stond hard op $/£
         op een winkel die in euro's verkoopt. */
      var symbol = (iso === 'GBP') ? '\u00a3' : (iso === 'USD') ? '$' : '\u20ac';
      return (iso === 'USD' || iso === 'GBP')
        ? symbol + (cents / 100).toFixed(2)
        : (cents / 100).toFixed(2).replace('.', ',') + '\u00a0' + symbol;
    }

    /* Het variant-id komt uit window.cartDrawerExt (gezet in het Liquid-blok
       bovenaan dit bestand). Bestaat het product 'shipping-protection' niet in
       deze winkel, dan is het 0 en staat de hele verzendbescherming uit -
       in plaats van op elke paginaweergave een 422 te blijven proberen. */
    var SP_HANDLE = 'shipping-protection';
    var SP_VARIANT_ID = (cfg && cfg.shippingProtectionVariantId) || 0;
    var SP_ENABLED = SP_VARIANT_ID > 0;
    var SP_PRICE = (cfg && cfg.shippingProtectionPrice) || 0;

    /* Shipping protection is geen kledingstuk en telt dus NIET mee voor de
       staffelkorting: de automatische kortingen in Shopify draaien op de
       collectie Shop All, waar protection niet in zit. Zonder deze filter
       belooft de balk een korting die de checkout niet geeft. */
    function getTotalQty(cart) {
      if (!cart || !cart.items) return 0;
      return cart.items.reduce(function(sum, item) {
        if (item.handle === SP_HANDLE) return sum;
        return sum + item.quantity;
      }, 0);
    }

    function getActiveTier(qty) {
      var tiers = cfg.discount.tiers;
      var active = null;
      for (var i = 0; i < tiers.length; i++) {
        if (qty >= tiers[i].minQty) active = tiers[i];
      }
      return active;
    }

    function getNextTier(qty) {
      var tiers = cfg.discount.tiers;
      for (var i = 0; i < tiers.length; i++) {
        if (qty < tiers[i].minQty) return tiers[i];
      }
      return null;
    }

    function renderQtyProgress(cart) {
      /* Lade EN cart page dragen dezelfde haken, dus alle treffers bijwerken. */
      document.querySelectorAll('[data-qty-progress-bar]').forEach(function (el) { renderQtyProgressOne(cart, el); });
    }

    function renderQtyProgressOne(cart, bar) {

      var qty = getTotalQty(cart);
      var tiers = cfg.discount.tiers;

      /* De markers staan op 0% / 50% / 100%, dus de vulling moet op de bereikte
         marker eindigen in plaats van op een aantal-verhouding. */
      var reachedIndex = -1;
      for (var t = 0; t < tiers.length; t++) {
        if (qty >= tiers[t].minQty) reachedIndex = t;
      }
      /* Markers staan op de middens van drie gelijke vakken (1/6, 3/6, 5/6). De vulling
         eindigt op de bereikte marker; bij de hoogste trede loopt hij helemaal vol. */
      var stops = [];
      for (var q = 0; q < tiers.length; q++) stops.push(((2 * q + 1) / (2 * tiers.length)) * 100);
      /* Tussen twee tredes vult de balk naar rato mee (1 van de 2 stuks = halverwege
         de eerste ring). Zonder dat stond hij bij één artikel op exact nul en leek
         hij kapot - de referentie toont juist dat korte rode stukje. */
      var fillPct;
      if (reachedIndex >= tiers.length - 1) {
        fillPct = 100;
      } else {
        var prevStop = reachedIndex < 0 ? 0 : stops[reachedIndex];
        var prevQty = reachedIndex < 0 ? 0 : tiers[reachedIndex].minQty;
        var nextT = tiers[reachedIndex + 1];
        var frac = Math.min(1, Math.max(0, (qty - prevQty) / (nextT.minQty - prevQty)));
        fillPct = prevStop + (stops[reachedIndex + 1] - prevStop) * frac;
      }

      var fill = bar.querySelector('[data-qty-fill]');
      if (fill) fill.style.width = fillPct + '%';

      var msg = bar.querySelector('[data-qty-message]');
      if (msg) {
        /* "Great choice! Add 1 more item to unlock 15% extra off" was een
           instructie zonder beloning. Het percentage stond klein tussen de
           rest, en nergens stond dat de korting over de HELE bestelling gaat -
           precies het feit dat iemand met één artikel over de streep trekt.
           Nu: de beloning vooraan en groot, de werking op de onderregel. */
        var activeTier = getActiveTier(qty);
        var nextTier = getNextTier(qty);
        var target = nextTier || tiers[0];
        var need = target.minQty - qty;
        /* Alles op EEN regel. De onderregel eronder legde uit dat de korting over
           de hele bestelling gaat, maar kostte in de lade meer hoogte dan dat
           zinnetje waard was; "your order" staat nu in de regel zelf. Elke tekst
           hieronder past op een lade van 330px zonder om te breken. */
        var html;
        var pct = function (n) { return '\u2212' + n + '\u00a0%'; };
        if (activeTier && !nextTier) {
          html = '<strong class="cdqp-pct">' + pct(activeTier.pct) + '</strong> sur votre commande, le maximum';
        } else if (activeTier) {
          html = '<span class="cdqp-lead">' + pct(activeTier.pct) + '</span> obtenu. ' +
                 'Encore ' + need + ' pour <strong class="cdqp-pct">' + pct(nextTier.pct) + '</strong>';
        } else if (qty > 0) {
          html = '<strong>' + need + ' article' + (need > 1 ? 's' : '') + '</strong> et vous obtenez <strong class="cdqp-pct">' +
                 pct(target.pct) + '</strong> sur toute la commande';
        } else {
          html = 'Ajoutez <strong>' + target.minQty + ' articles</strong> et obtenez <strong class="cdqp-pct">' +
                 pct(target.pct) + '</strong>';
        }
        msg.innerHTML = html;

        /* Eén artikel te gaan: dan mag de eerstvolgende ring kloppen. Alleen dan,
           en niet meer als de hoogste trede al binnen is. */
        bar.classList.toggle('is-close', need === 1 && !(activeTier && !nextTier));
      }

      bar.querySelectorAll('[data-qty-marker]').forEach(function(marker) {
        var markerQty = parseInt(marker.getAttribute('data-qty-marker'), 10);
        marker.classList.toggle('is-reached', qty >= markerQty);
        /* De trede waar je nu naartoe werkt. Die ene mag kloppen als hij op
           één artikel afstand staat; de rest blijft rustig. */
        marker.classList.toggle('is-next', !!nextTier && markerQty === nextTier.minQty);
      });

      bar.setAttribute('aria-valuenow', fillPct);
    }

    /* Per-unit compare-at: prefer Liquid map, then live fetch result, then cart field */
    function getUnitCompare(item) {
      var vid = item.variant_id;
      if (compareCache[vid] != null) return compareCache[vid];
      if (item.compare_at_price != null) return item.compare_at_price;
      return 0;
    }

    /* For variants not in the Liquid map (e.g. added during this session),
       fetch the product JSON once and cache compare-at for all its variants,
       then re-render savings. Queued, so it never competes with a cart write. */
    function enrichCompare(cart) {
      if (!cart.items) return;
      var handles = {};
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        if (compareCache[item.variant_id] == null && item.handle && !compareFetchTried[item.handle]) {
          handles[item.handle] = true;
        }
      }
      var list = Object.keys(handles);
      if (!list.length) return;
      list.forEach(function(handle) {
        compareFetchTried[handle] = true;
        queueTask(function() {
          return ajaxJson(SHOP_ROOT + 'products/' + handle + '.js', { credentials: 'same-origin' });
        })
        .then(function(product) {
          if (product && product.variants) {
            product.variants.forEach(function(v) {
              compareCache[v.id] = v.compare_at_price || 0;
            });
          }
          renderSavings(cart);
        })
        .catch(noop);
      });
    }

    /* Compare-at markdown vs selling price (original_price), so it does NOT
       double-count with cart.total_discount */
    function computeCompareSavings(cart) {
      var total = 0;
      if (!cart.items) return 0;
      for (var i = 0; i < cart.items.length; i++) {
        var item = cart.items[i];
        var compare = getUnitCompare(item);
        var selling = (item.original_price != null) ? item.original_price : (item.price || 0);
        if (compare > selling) {
          total += (compare - selling) * item.quantity;
        }
      }
      return total;
    }

    /* Total savings = compare-at markdown + ALL cart discounts (tier + codes).
       Shows whenever the sum is positive, also with no discount code. */
    function renderSavings(cart) {
      /* Lade EN cart page dragen dezelfde haken, dus alle treffers bijwerken. */
      document.querySelectorAll('[data-savings-row]').forEach(function (el) { renderSavingsOne(cart, el); });
    }

    function renderSavingsOne(cart, row) {
      var amountEl = row.querySelector('[data-savings-amount]');
      if (!amountEl) return;
      /* Alleen de afprijzing en de automatische staffel; wat een ingetikte code
         doet staat op zijn eigen regel (renderDiscountCodes). Samen tellen ze
         nog steeds op tot het verschil tussen subtotaal en totaal. */
      var totalSavings = computeCompareSavings(cart) +
                         (cart.total_discount || 0) - codeDiscountTotal(cart);
      if (totalSavings > 0) {
        amountEl.textContent = '-' + formatMoney(totalSavings, cart.currency || 'USD');
        row.removeAttribute('hidden');
      } else {
        row.setAttribute('hidden', '');
      }
    }

    /* Manual discount code chips (automatic discounts don't appear here) */
    /* Wat een INGETIKTE code oplevert, per code en met bedrag.

       Waarom apart: de regel "Fall Kickoff Sale" telde de afprijzing, de
       automatische staffelkorting en de code bij elkaar op. Een klant die
       WELCOME10 invulde zag het totaal veranderen maar nergens hoeveel die code
       nou deed - precies de vraag die je op dat moment stelt.

       cart.discount_applications kent per toepassing een `type`; alleen
       'discount_code' komt van een ingetikte code. Wat overblijft (afprijzing +
       automatische kortingen) blijft op de saleregel staan, zie renderSavings. */
    /* Ingetikte codes staan op TWEE plekken in /cart.js, en `discount_applications`
       is er niet een van - die is in de Ajax-cart leeg (gemeten 08-09-2026 met
       WELCOME10 erin). Een cart-brede code zit in
       `cart_level_discount_applications`; een code die op regelniveau valt zit in
       `line_level_discount_allocations` van elk artikel. Lees ze allebei, anders
       mist de helft van de gevallen. */
    function codeDiscounts(cart) {
      var out = {};
      function add(title, amount) {
        if (!title || !amount) return;
        out[title] = (out[title] || 0) + amount;
      }
      var cl = cart.cart_level_discount_applications || [];
      for (var i = 0; i < cl.length; i++) {
        if (cl[i] && cl[i].type === 'discount_code') add(cl[i].title, cl[i].total_allocated_amount || 0);
      }
      var items = cart.items || [];
      for (var j = 0; j < items.length; j++) {
        var allocs = items[j].line_level_discount_allocations || [];
        for (var k = 0; k < allocs.length; k++) {
          var app = allocs[k] && allocs[k].discount_application;
          if (app && app.type === 'discount_code') add(app.title, allocs[k].amount || 0);
        }
      }
      return out;
    }

    function codeDiscountTotal(cart) {
      var map = codeDiscounts(cart), total = 0;
      for (var k in map) if (Object.prototype.hasOwnProperty.call(map, k)) total += map[k];
      return total;
    }

    function renderDiscountCodes(cart) {
      /* Lade EN cart page dragen dezelfde haken, dus alle treffers bijwerken. */
      document.querySelectorAll('[data-discount-codes]').forEach(function (el) { renderDiscountCodesOne(cart, el); });
    }

    function renderDiscountCodesOne(cart, container) {

      /* Shopify accepteert maar EEN code per checkout. Zodra er een op de
         sessie staat is "Add discount code" dode ruimte die suggereert dat je
         kunt stapelen; dan gaat die regel dicht. */
      var hasCode = (cart.discount_codes || []).some(function (d) {
        return d && d.code && d.applicable !== false;
      });
      document.querySelectorAll('.bom-cf__coderow').forEach(function (addRow) { addRow.hidden = hasCode; });

      var map = codeDiscounts(cart);
      var apps = Object.keys(map).map(function (title) {
        return { title: title, total_allocated_amount: map[title] };
      });

      if (apps.length === 0) {
        /* Terugval: een code die (nog) niets oplevert staat wel in
           discount_codes maar niet als toepassing met een bedrag. Die tonen we
           als chip zonder bedrag, zodat hij niet stilletjes verdwijnt. */
        var codes = (cart.discount_codes || []).filter(function (d) {
          return d && d.code && d.applicable !== false;
        });
        container.innerHTML = codes.length === 0 ? '' :
          '<div class="cart-drawer-discount__row">' +
          codes.map(function (d) {
            /* Terugvalpad zonder bedrag: zeg er dan bij dat hij in het rode
               bedrag hierboven zit, anders lijkt de code niets te doen. */
            return '<span class="cart-drawer-discount__tag">' + d.code + '</span>' +
                   '<span class="cart-drawer-discount__note">included in the discount above</span>';
          }).join('') + '</div>';
        return;
      }

      var tagIcon = '<svg class="bom-cf__code-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z"/><line x1="7" y1="7" x2="7.01" y2="7"/></svg>';
      container.innerHTML = apps.map(function (d) {
        return '<div class="bom-cf__row bom-cf__row--code">' +
                 '<span class="bom-cf__code-name">' + tagIcon +
                   '<span class="bom-cf__code-tag">' + d.title + '</span>' +
                 '</span>' +
                 '<span>-' + formatMoney(d.total_allocated_amount || 0, cart.currency || 'USD') + '</span>' +
               '</div>';
      }).join('');
    }

    /* Subtotaal, aantal en de "checking out now"-regel in de voet van de lade.
       De markup hoort bij snippets/cart-drawer.liquid; deze functie vult hem.

       Subtotaal = totaal + alle besparing, dus de prijs VOOR de afprijzing en
       voor de kortingen. Dat is precies wat de kortingsregel eronder er weer
       afhaalt, zodat de drie regels optellen. Rekent hij ooit anders dan
       renderSavings(), dan klopt de som niet meer - houd ze bij elkaar.

       Het aantal komt uit getTotalQty(), die shipping-protection overslaat: die
       regel is geen artikel en telt ook niet mee voor de staffelkorting.

       Het aantal mensen dat "nu afrekent" is een SCHATTING, geen meting. Hij
       loopt met het kwartier mee zodat hij binnen een sessie niet zichtbaar op
       en neer springt; er is geen bron die dit echt kan tellen. Wil je hem weg:
       haal .bom-cf__proof uit cart-drawer.liquid, deze functie faalt dan stil. */
    function renderBomSummary(cart) {
      var savings = computeCompareSavings(cart) + (cart.total_discount || 0);

      document.querySelectorAll('[data-bom-subtotal]').forEach(function (subtotalEl) {
        subtotalEl.innerHTML = formatMoney((cart.total_price || 0) + savings, cart.currency || 'USD');
      });

      var qty = getTotalQty(cart);
      document.querySelectorAll('[data-bom-count]').forEach(function (countEl) {
        countEl.textContent = qty + (qty === 1 ? ' article' : ' articles');
      });    }

    function updateCheckoutTotal(cart) {
      var totalEls = document.querySelectorAll('[data-cart-total]');
      if (!totalEls.length) return;
      var total = cart.total_price || 0;
      var formatted = formatMoney(total, cart.currency || 'USD');
      for (var i = 0; i < totalEls.length; i++) {
        totalEls[i].innerHTML = formatted;
      }
    }

    /* ── Upsell carousel (Shopify product recommendations) ── */
    function escapeHtml(str) {
      return String(str == null ? '' : str)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function sizedImage(url, w) {
      if (!url) return '';
      if (url.indexOf('//') === 0) url = 'https:' + url;
      return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200);
    }

    /* product.options can be ["Color","Shoe Size"] or [{name:"Color"}, ...] */
    function optionNamesOf(p) {
      var names = [];
      var raw = p.options || [];
      for (var i = 0; i < raw.length; i++) {
        var o = raw[i];
        if (o && typeof o === 'object') names.push(o.name || ('Option ' + (i + 1)));
        else names.push(String(o == null ? ('Option ' + (i + 1)) : o));
      }
      return names;
    }

    function variantOptionsOf(v) {
      if (Array.isArray(v.options) && v.options.length) return v.options.slice();
      var out = [];
      if (v.option1 != null) out.push(v.option1);
      if (v.option2 != null) out.push(v.option2);
      if (v.option3 != null) out.push(v.option3);
      return out;
    }

    function mapUpsellProduct(p) {
      var variants = (p.variants || []).map(function(v) {
        return {
          id: v.id,
          title: v.title,
          price: v.price,
          compare: v.compare_at_price || 0,
          available: v.available !== false,
          options: variantOptionsOf(v)
        };
      });

      var maxOpts = 0;
      variants.forEach(function(v) { if (v.options.length > maxOpts) maxOpts = v.options.length; });

      var names = optionNamesOf(p);
      if (names.length > maxOpts) names = names.slice(0, maxOpts);
      while (names.length < maxOpts) names.push('Option ' + (names.length + 1));

      return {
        id: p.id,
        title: p.title,
        url: p.url || (SHOP_ROOT + 'products/' + p.handle),
        handle: p.handle,
        image: p.featured_image || (p.images && p.images[0]) || '',
        available: p.available !== false,
        optionNames: names,
        variants: variants
      };
    }

    function findProduct(id) {
      for (var i = 0; i < upsellState.products.length; i++) {
        if (String(upsellState.products[i].id) === String(id)) return upsellState.products[i];
      }
      return null;
    }

    function hasRealOptions(p) {
      if (!p || !p.variants.length) return false;
      if (p.variants.length === 1 && /default title/i.test(p.variants[0].title || '')) return false;
      return p.optionNames.length > 0;
    }

    function optionValues(p, index) {
      var seen = {}, out = [];
      p.variants.forEach(function(v) {
        var val = v.options[index];
        if (val == null || val === '') return;
        if (!seen[val]) { seen[val] = true; out.push(val); }
      });
      return out;
    }

    function sameVal(a, b) {
      return String(a == null ? '' : a) === String(b == null ? '' : b);
    }

    function findVariant(p, selection) {
      for (var i = 0; i < p.variants.length; i++) {
        var v = p.variants[i], ok = true;
        for (var j = 0; j < p.optionNames.length; j++) {
          if (!sameVal(v.options[j], selection[j])) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function defaultSelection(p) {
      var v = null;
      for (var i = 0; i < p.variants.length; i++) {
        if (p.variants[i].available) { v = p.variants[i]; break; }
      }
      if (!v) v = p.variants[0];
      return v ? v.options.slice() : [];
    }

    /* Reads the current choice per option index, from its own select or,
       for options with only one possible value, from the fixed attribute */
    function slideSelection(slide, p) {
      var sel = [];
      for (var i = 0; i < p.optionNames.length; i++) {
        var el = slide.querySelector('[data-upsell-option="' + i + '"]');
        if (el) sel.push(el.value);
        else sel.push(slide.getAttribute('data-fixed-' + i) || '');
      }
      return sel;
    }

    function resolveVariant(slide, p) {
      if (!p) return null;
      if (!hasRealOptions(p)) return p.variants[0] || null;
      return findVariant(p, slideSelection(slide, p));
    }

    function buildOptionSelect(p, index, start) {
      var values = optionValues(p, index);
      var opts = values.map(function(val) {
        return '<option value="' + escapeHtml(val) + '"' +
          (sameVal(val, start[index]) ? ' selected' : '') + '>' +
          escapeHtml(val) + '</option>';
      }).join('');
      return '<select class="cart-drawer-upsell__select" data-upsell-option="' + index + '"' +
        ' aria-label="' + escapeHtml(p.optionNames[index]) + '">' + opts + '</select>';
    }

    function buildUpsellSlide(p) {
      var start = defaultSelection(p);
      var def = findVariant(p, start) || p.variants[0];
      var img = sizedImage(p.image, 200);
      var fixedAttrs = '';
      var selectsHtml = '';

      if (hasRealOptions(p)) {
        var parts = [];
        for (var i = 0; i < p.optionNames.length; i++) {
          var values = optionValues(p, i);
          if (values.length <= 1) {
            fixedAttrs += ' data-fixed-' + i + '="' + escapeHtml(values[0] || start[i] || '') + '"';
            continue;
          }
          parts.push(buildOptionSelect(p, i, start));
        }
        if (parts.length) selectsHtml = '<div class="cart-drawer-upsell__options">' + parts.join('') + '</div>';
      }

      return '<div class="cart-drawer-upsell__slide" data-upsell-slide' +
        ' data-product-id="' + p.id + '" data-variant-id="' + (def ? def.id : '') + '"' + fixedAttrs + '>' +
        '<a class="cart-drawer-upsell__image" href="' + p.url + '">' +
          (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="cart-drawer-upsell__info">' +
          '<a class="cart-drawer-upsell__name" href="' + p.url + '">' + escapeHtml(p.title) + '</a>' +
          '<div class="cart-drawer-upsell__price-row">' +
            '<span class="cart-drawer-upsell__price-compare" data-upsell-compare hidden></span>' +
            '<span class="cart-drawer-upsell__price-sale" data-upsell-price></span>' +
          '</div>' +
          selectsHtml +
        '</div>' +
        '<button type="button" class="cart-drawer-upsell__add" data-upsell-add>+ Add</button>' +
      '</div>';
    }

    /* Keeps price, compare-at, sold out labels, variant id and button in sync
       with whatever the dropdowns currently say */
    function syncSlide(slide) {
      var p = findProduct(slide.getAttribute('data-product-id'));
      if (!p) return;

      var selection = hasRealOptions(p) ? slideSelection(slide, p) : [];
      var variant = resolveVariant(slide, p);

      Array.prototype.forEach.call(slide.querySelectorAll('[data-upsell-option]'), function(sel) {
        var idx = parseInt(sel.getAttribute('data-upsell-option'), 10);
        Array.prototype.forEach.call(sel.options, function(opt) {
          var test = selection.slice();
          test[idx] = opt.value;
          var v = findVariant(p, test);
          opt.textContent = opt.value + ((!v || !v.available) ? ' (\u00e9puis\u00e9)' : '');
        });
      });

      slide.setAttribute('data-variant-id', variant ? variant.id : '');

      var priceEl = slide.querySelector('[data-upsell-price]');
      if (priceEl) priceEl.textContent = variant ? formatMoney(variant.price, lastCurrency) : '';

      var compEl = slide.querySelector('[data-upsell-compare]');
      if (compEl) {
        if (variant && variant.compare && variant.compare > variant.price) {
          compEl.textContent = formatMoney(variant.compare, lastCurrency);
          compEl.removeAttribute('hidden');
        } else {
          compEl.setAttribute('hidden', '');
        }
      }

      var btn = slide.querySelector('[data-upsell-add]');
      if (btn && btn.getAttribute('data-busy') !== '1') {
        var ok = !!(variant && variant.available);
        btn.disabled = !ok;
        btn.textContent = ok ? '+ Ajouter' : 'Épuisé';
      }
    }

    /* Keep the option the shopper just picked, move the other selects to a
       combination that actually exists */
    function onOptionChange(sel) {
      var slide = sel.closest('[data-upsell-slide]');
      if (!slide) return;
      var p = findProduct(slide.getAttribute('data-product-id'));
      if (!p) return;

      var idx = parseInt(sel.getAttribute('data-upsell-option'), 10);
      var selection = slideSelection(slide, p);
      var match = findVariant(p, selection);

      if (!match || !match.available) {
        var fallback = null;
        for (var i = 0; i < p.variants.length; i++) {
          if (sameVal(p.variants[i].options[idx], selection[idx]) && p.variants[i].available) {
            fallback = p.variants[i];
            break;
          }
        }
        if (fallback) {
          Array.prototype.forEach.call(slide.querySelectorAll('[data-upsell-option]'), function(other) {
            var oi = parseInt(other.getAttribute('data-upsell-option'), 10);
            if (oi !== idx) other.value = fallback.options[oi];
          });
        }
      }

      syncSlide(slide);
    }

    function cartProductIds(cart) {
      var ids = {};
      if (cart && cart.items) {
        cart.items.forEach(function(it) { ids[it.product_id] = true; });
      }
      return ids;
    }

    function applyUpsellTrack(container) {
      var track = container.querySelector('[data-upsell-track]');
      if (track) track.style.transform = 'translateX(-' + (upsellState.index * 100) + '%)';
    }

    function renderUpsell(cart) {
      var container = document.querySelector('[data-upsell]');
      if (!container) return;
      if (!cfg.upsell || !cfg.upsell.enable) { container.setAttribute('hidden', ''); return; }

      var inCart = cartProductIds(cart);
      var list = upsellState.products.filter(function(p) { return !inCart[p.id]; });

      if (!list.length) { container.setAttribute('hidden', ''); return; }

      var headingEl = container.querySelector('[data-upsell-heading]');
      if (headingEl && cfg.upsell.heading) headingEl.textContent = cfg.upsell.heading;

      var sig = list.map(function(p) { return p.id; }).join(',');
      var track = container.querySelector('[data-upsell-track]');

      /* rebuild when the list changed OR when the theme wiped the track
         during a cart re-render */
      if (track && (sig !== upsellState.sig || !track.children.length)) {
        track.innerHTML = list.map(function(p) { return buildUpsellSlide(p); }).join('');
        if (sig !== upsellState.sig) upsellState.index = 0;
        upsellState.sig = sig;
        Array.prototype.forEach.call(track.querySelectorAll('[data-upsell-slide]'), function(slide) {
          syncSlide(slide);
        });
      }

      if (upsellState.index > list.length - 1) upsellState.index = list.length - 1;
      if (upsellState.index < 0) upsellState.index = 0;

      applyUpsellTrack(container);

      var nav = container.querySelector('[data-upsell-nav]');
      if (nav) {
        if (list.length > 1) nav.removeAttribute('hidden');
        else nav.setAttribute('hidden', '');
      }

      container.removeAttribute('hidden');
    }

    function loadUpsell(cart) {
      var container = document.querySelector('[data-upsell]');
      if (!container) return;
      if (!cfg.upsell || !cfg.upsell.enable) { container.setAttribute('hidden', ''); return; }
      if (!cart || !cart.items || !cart.items.length) { container.setAttribute('hidden', ''); return; }

      var seed = cart.items[0].product_id;
      if (upsellState.fetched && upsellState.seed === seed) {
        renderUpsell(cart);
        return;
      }
      upsellState.seed = seed;
      var limit = (cfg.upsell.limit && cfg.upsell.limit > 0) ? cfg.upsell.limit : 8;
      var url = SHOP_ROOT + 'recommendations/products.json?product_id=' + seed + '&limit=' + limit + '&intent=related';

      queueTask(function() {
        return ajaxJson(url, { credentials: 'same-origin' });
      })
      .then(function(data) {
        var prods = (data && data.products) ? data.products : [];
        upsellState.products = prods.map(mapUpsellProduct).filter(function(p) {
          return p && p.available !== false && p.variants.some(function(v) { return v.available; });
        });
        upsellState.fetched = true;
        upsellState.sig = '';
        renderUpsell(cart);
      })
      .catch(function(err) {
        console.error('[cart-drawer-ext] recommendations failed', err);
        upsellState.products = [];
        upsellState.fetched = true;
        renderUpsell(cart);
      });
    }

    function moveUpsell(dir) {
      var container = document.querySelector('[data-upsell]');
      if (!container) return;
      var track = container.querySelector('[data-upsell-track]');
      if (!track) return;
      var count = track.children.length;
      if (count <= 1) return;
      upsellState.index = (upsellState.index + dir + count) % count;
      applyUpsellTrack(container);
    }

    function upsellAdd(slide, btn) {
      if (!slide) return;
      if (btn && btn.getAttribute('data-busy') === '1') return;

      var p = findProduct(slide.getAttribute('data-product-id'));
      var variant = resolveVariant(slide, p);
      var id = parseInt(variant ? variant.id : slide.getAttribute('data-variant-id'), 10);

      if (!id) {
        console.error('[cart-drawer-ext] add: no variant resolved for product', slide.getAttribute('data-product-id'));
        return;
      }
      if (variant && !variant.available) return;

      if (btn) {
        btn.setAttribute('data-busy', '1');
        btn.disabled = true;
        btn.textContent = 'Adding...';
      }

      queueTask(function() {
        return ajaxJson(SHOP_ROOT + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: JSON_HEADERS,
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
        });
      })
      .then(function() {
        return getCart(true);
      })
      .then(function(cart) {
        if (btn) {
          btn.setAttribute('data-busy', '0');
          btn.disabled = false;
          btn.textContent = '+ Add';
        }
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function(err) {
        console.error('[cart-drawer-ext] add failed', err && err.status, err && err.message, err && err.data);
        if (btn) {
          btn.setAttribute('data-busy', '0');
          btn.disabled = false;
          btn.textContent = 'Try again';
          setTimeout(function() {
            if (btn.getAttribute('data-busy') !== '1') btn.textContent = '+ Add';
          }, 2500);
        }
        scheduleRender(400);
      });
    }


    function renderFromCart(cart) {
      if (!cart) return;
      lastCart = cart;
      lastCurrency = cart.currency || lastCurrency || 'USD';
      renderQtyProgress(cart);
      renderShippingProtection(cart);
      maybeAutoAddProtection(cart);
      cleanupOrphanProtection(cart);
      renderDiscountCodes(cart);
      renderSavings(cart);
      updateCheckoutTotal(cart);
      renderBomSummary(cart);
      enrichCompare(cart);
      loadUpsell(cart);
    }

    /* ── Backup: re-inject +/- icons if the theme removes them from the DOM ── */
    var qtyIconCache = {};

    function classifyQtyBtn(btn) {
      var hay = ((btn.className || '') + ' ' +
                 (btn.getAttribute('data-adjust') || '') + ' ' +
                 (btn.getAttribute('data-qty-adjust') || '') + ' ' +
                 (btn.getAttribute('aria-label') || '')).toLowerCase();
      if (/minus|decrease|subtract/.test(hay)) return 'minus';
      if (/plus|increase|\badd\b/.test(hay)) return 'plus';
      return null;
    }

    function captureQtyIcons() {
      var scope = document.getElementById('CartDrawer');
      if (!scope) return;
      scope.querySelectorAll('.js-qty__adjust').forEach(function(btn) {
        var type = classifyQtyBtn(btn);
        if (type && !qtyIconCache[type] && btn.querySelector('svg')) {
          qtyIconCache[type] = btn.innerHTML;
        }
      });
    }

    function restoreQtyIcons() {
      var scope = document.getElementById('CartDrawer');
      if (!scope) return;
      scope.querySelectorAll('.js-qty__adjust').forEach(function(btn) {
        if (btn.querySelector('svg')) return;
        var type = classifyQtyBtn(btn);
        if (type && qtyIconCache[type]) btn.innerHTML = qtyIconCache[type];
      });
    }

    function watchQtyIcons() {
      var scope = document.getElementById('CartDrawer');
      if (!scope || typeof MutationObserver === 'undefined') return;
      var target = scope.querySelector('[data-products]') || scope;
      var obs = new MutationObserver(function() {
        captureQtyIcons();
        restoreQtyIcons();
      });
      obs.observe(target, { childList: true, subtree: true });
    }

    function handleRemoveClick(e) {
      var btn = e.target.closest('[data-cart-remove]');
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('data-removing') === '1') return;
      var key = btn.getAttribute('data-cart-key');
      if (!key) return;

      btn.setAttribute('data-removing', '1');
      var item = btn.closest('.cart-item-custom');
      if (item) item.classList.add('is-loading');

      /* cart/change.js already returns the full cart, so no extra /cart.js */
      queueTask(function() {
        return ajaxJson(SHOP_ROOT + 'cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: JSON_HEADERS,
          body: JSON.stringify({ id: key, quantity: 0 })
        });
      })
      .then(function(cart) {
        btn.setAttribute('data-removing', '0');
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      })
      .catch(function(err) {
        console.error('[cart-drawer-ext] remove failed', err && err.status, err && err.message);
        if (item) item.classList.remove('is-loading');
        btn.setAttribute('data-removing', '0');
      });
    }

    /* ── Shipping protection: kleine toggle onderin de drawer ── */
    function findProtectionLine(cart) {
      if (!cart || !cart.items) return null;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].handle === SP_HANDLE) return cart.items[i];
      }
      return null;
    }

    /* 20-09-2026: shipping protection staat weer standaard AAN.

       Op 07-09 is hij opt-in gemaakt omdat het product op DRAFT stond en niet
       op het Online Store-kanaal: elke add kwam terug als "422 Cannot find
       variant", dus het vinkje deed niets. Dat is verholpen - het product is
       ACTIVE, gepubliceerd, en verkoopt door bij voorraad 0 (inventoryPolicy
       CONTINUE), dus de add lukt altijd.

       De regel blijft ONZICHTBAAR als artikel: cart.ajax.liquid en
       main-cart.liquid slaan het handle over in de rijenlijst, en het aantal
       (telbadge, "N items", lege-tas-toestand) telt hem nergens mee. Het
       vinkje onderin is de enige plek waar hij staat, en dat is ook de plek
       waar de klant hem uit kan zetten.

       SP_OPTOUT_KEY houdt zo'n handmatige uitvink vast voor de rest van de
       sessie, anders zet de automaat hem bij de volgende render meteen terug. */
    var SP_OPTOUT_KEY = 'bom_sp_optout';
    var spAutoAddTried = false;
    var spCleanupBusy = false;

    /* De /cart-pagina is Dawn's main-cart-items + main-cart-footer, en die
       luisteren niet naar cart:updated. Verandert de bescherming daar, dan
       herladen we, anders klopt het totaal onderaan niet. */
    function spAfterChange(cart) {
      if (/\/cart\/?$/.test(window.location.pathname)) { window.location.reload(); return; }
      document.dispatchEvent(new CustomEvent('cart:build'));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    }

    function spOptedOut() {
      try { return !!window.sessionStorage && sessionStorage.getItem(SP_OPTOUT_KEY) === '1'; }
      catch (e) { return false; }
    }

    function spRealItems(cart) {
      if (!cart || !cart.items) return 0;
      return cart.items.filter(function (i) { return i.handle !== SP_HANDLE; }).length;
    }

    /* EEN poging per paginaweergave. De vlag gaat om VOOR het verzoek, want de
       add vuurt cart:updated af en die render komt hier meteen weer langs; zonder
       die volgorde blijft hij rondjes draaien op een mislukte add. */
    function maybeAutoAddProtection(cart) {
      if (!SP_ENABLED) return;
      if (spAutoAddTried || spOptedOut()) return;
      if (!cart || findProtectionLine(cart)) return;
      if (!spRealItems(cart)) return;

      spAutoAddTried = true;
      queueTask(function () {
        return ajaxJson(SHOP_ROOT + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin', headers: JSON_HEADERS,
          body: JSON.stringify({ items: [{ id: SP_VARIANT_ID, quantity: 1 }] })
        });
      })
      .then(function () { return getCart(true); })
      .then(function (fresh) {
        spAfterChange(fresh);
      })
      .catch(function (err) {
        console.warn('[cart-drawer-ext] auto shipping protection failed', err && err.status, err && err.message);
      });
    }

    /* Haalt de klant zijn laatste artikel weg, dan blijft anders een tas van
       $3.95 bescherming over die nergens als regel te zien is en dus ook niet
       weg te klikken. Ruim hem op, dan is de tas echt leeg. */
    function cleanupOrphanProtection(cart) {
      if (spCleanupBusy || !cart) return;
      var line = findProtectionLine(cart);
      if (!line || spRealItems(cart)) return;

      spCleanupBusy = true;
      queueTask(function () {
        return ajaxJson(SHOP_ROOT + 'cart/change.js', {
          method: 'POST', credentials: 'same-origin', headers: JSON_HEADERS,
          body: JSON.stringify({ id: line.key, quantity: 0 })
        });
      })
      .then(function () {
        /* De tas is nu leeg, dus de volgende vulling mag de bescherming weer
           automatisch aanzetten. */
        spAutoAddTried = false;
        return getCart(true);
      })
      .then(function (fresh) {
        spCleanupBusy = false;
        spAfterChange(fresh);
      })
      .catch(function (err) {
        spCleanupBusy = false;
        console.warn('[cart-drawer-ext] orphan shipping protection cleanup failed', err && err.status, err && err.message);
      });
    }

    function renderShippingProtection(cart) {
      /* Lade EN cart page dragen dezelfde haken, dus alle treffers bijwerken. */
      document.querySelectorAll('[data-cdsp]').forEach(function (el) { renderShippingProtectionOne(cart, el); });
    }

    function renderShippingProtectionOne(cart, box) {
      var hasItems = cart && cart.items && cart.items.some(function(i) { return i.handle !== SP_HANDLE; });
      if (!hasItems) { box.setAttribute('hidden', ''); return; }
      box.removeAttribute('hidden');

      var line = findProtectionLine(cart);
      var input = box.querySelector('[data-cdsp-input]');
      var price = box.querySelector('[data-cdsp-price]');
      if (input && input.getAttribute('data-busy') !== '1') input.checked = !!line;
      box.classList.toggle('is-on', !!line);
      if (price) price.textContent = line ? formatMoney(line.final_line_price) : '+ ' + formatMoney(SP_PRICE);
    }

    function onProtectionToggle(e) {
      var input = e.target.closest('[data-cdsp-input]');
      if (!input) return;
      var wants = input.checked;
      try { if (window.sessionStorage) { if (wants) sessionStorage.removeItem(SP_OPTOUT_KEY); else sessionStorage.setItem(SP_OPTOUT_KEY, '1'); } } catch (e) {}
      input.setAttribute('data-busy', '1');
      input.disabled = true;

      getCart(true).then(function(cart) {
        var line = findProtectionLine(cart);
        if (wants && line) return cart;
        if (!wants && !line) return cart;
        if (wants) {
          if (!SP_ENABLED) return cart;
          return queueTask(function() {
            return ajaxJson(SHOP_ROOT + 'cart/add.js', {
              method: 'POST', credentials: 'same-origin', headers: JSON_HEADERS,
              body: JSON.stringify({ items: [{ id: SP_VARIANT_ID, quantity: 1 }] })
            });
          }).then(function() { return getCart(true); });
        }
        return queueTask(function() {
          return ajaxJson(SHOP_ROOT + 'cart/change.js', {
            method: 'POST', credentials: 'same-origin', headers: JSON_HEADERS,
            body: JSON.stringify({ id: line.key, quantity: 0 })
          });
        });
      })
      .then(function(cart) {
        input.setAttribute('data-busy', '0');
        input.disabled = false;
        spAfterChange(cart);
      })
      .catch(function(err) {
        console.error('[cart-drawer-ext] shipping protection failed', err && err.status, err && err.message);
        input.setAttribute('data-busy', '0');
        input.disabled = false;
        input.checked = !wants;
      });
    }

    document.addEventListener('change', function(e) {
      if (e.target && e.target.closest && e.target.closest('[data-cdsp-input]')) onProtectionToggle(e);
    });

    function applyGuaranteeBadge() {
      var holder = document.querySelector('[data-guarantee]');
      if (!holder) return;
      if (!cfg.guarantee.enable) {
        holder.setAttribute('hidden', '');
        return;
      }
      holder.removeAttribute('hidden');
      var textEl = holder.querySelector('[data-guarantee-text]');
      if (textEl && cfg.guarantee.text) textEl.textContent = cfg.guarantee.text;
    }

    function applyPaymentIconVisibility() {
      document.querySelectorAll('[data-payment-icons]').forEach(function (holder) {
        if (!cfg.payment.enable) {
          holder.setAttribute('hidden', '');
        } else {
          holder.removeAttribute('hidden');
        }
      });
    }

    function scheduleIconFix() {
      setTimeout(function() { captureQtyIcons(); restoreQtyIcons(); }, 60);
    }

    function init() {
      applyGuaranteeBadge();
      applyPaymentIconVisibility();
      captureQtyIcons();
      watchQtyIcons();

      document.addEventListener('click', handleRemoveClick);

      /* Capture phase, so no theme or app handler can swallow the click
         before it reaches the upsell buttons */
      document.addEventListener('click', function(e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (t.closest('[data-upsell-prev]')) { moveUpsell(-1); return; }
        if (t.closest('[data-upsell-next]')) { moveUpsell(1); return; }
        var addBtn = t.closest('[data-upsell-add]');
        if (addBtn) {
          e.preventDefault();
          upsellAdd(addBtn.closest('[data-upsell-slide]'), addBtn);
        }
      }, true);

      document.addEventListener('change', function(e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var sel = t.closest('[data-upsell-option]');
        if (sel) {
          e.stopPropagation();
          onOptionChange(sel);
        }
      }, true);

      document.addEventListener('cart:updated', function(e) {
        var cart = e.detail && e.detail.cart;
        if (cart) renderFromCart(cart);
        else scheduleRender(150);
        scheduleIconFix();
      });

      document.addEventListener('cart:build', scheduleIconFix);

      /* Aantal wijzigen op /cart gaat via Dawn's pubsub, niet via cart:updated.
         Zonder dit blijft na het weghalen van het laatste artikel een tas van
         alleen bescherming staan. */
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () { scheduleRender(150); });
      }

      document.addEventListener('ajaxProduct:added', function() {
        scheduleRender(250);
        setTimeout(restoreQtyIcons, 350);
      });

      document.addEventListener('drawerOpen.CartDrawer', function() {
        scheduleRender(0);
        scheduleIconFix();
      });

      document.querySelectorAll('[data-icon-cart], .js-drawer-open-cart, [href$="/cart"]').forEach(function(btn) {
        btn.addEventListener('click', function() { scheduleRender(250); });
      });

      scheduleRender(0);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 768px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
